module.exports = __webpack_public_path__ + "static/media/infoEmptyList.26c0a4bd.svg";